import { useEffect, useState } from 'react'
import api from '@/services/api'

export type BlocoColleagueOption = { id: string; name: string; role?: string }

const ROLE_LABELS: Record<string, string> = {
  ADMIN: 'Admin',
  MANAGER: 'Gestor',
  CLOSER: 'Closer',
  BDR: 'BDR',
  CS: 'CS',
  FINANCEIRO: 'Financeiro',
  USUARIO_AGRADA: 'Usuário Agrada',
}

let colleaguesCache: BlocoColleagueOption[] | null = null
let colleaguesFetchPromise: Promise<BlocoColleagueOption[]> | null = null

export function formatColleagueRole(role?: string): string {
  if (!role) return ''
  return ROLE_LABELS[role.toUpperCase()] ?? role
}

async function fetchColleaguesList(): Promise<BlocoColleagueOption[]> {
  if (colleaguesCache) return colleaguesCache
  if (!colleaguesFetchPromise) {
    colleaguesFetchPromise = api
      .get('/users', {
        params: { role: 'crm', limit: 500, sortBy: 'name', sortOrder: 'asc' },
      })
      .then((resp) => {
        const raw = resp.data.data ?? resp.data ?? []
        const items = (Array.isArray(raw) ? raw : [])
          .map((user: { id: string; name: string; role?: string }) => ({
            id: user.id,
            name: user.name,
            role: user.role,
          }))
          .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))
        colleaguesCache = items
        return items
      })
      .catch(() => [] as BlocoColleagueOption[])
      .finally(() => {
        colleaguesFetchPromise = null
      })
  }
  return colleaguesFetchPromise
}

export function useBlocoColleagues(enabled: boolean) {
  const [colleagues, setColleagues] = useState<BlocoColleagueOption[]>(colleaguesCache ?? [])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled) return

    let cancelled = false
    setLoading(!colleaguesCache)

    void fetchColleaguesList().then((items) => {
      if (!cancelled) setColleagues(items)
    }).finally(() => {
      if (!cancelled) setLoading(false)
    })

    return () => {
      cancelled = true
    }
  }, [enabled])

  return { colleagues, loading }
}
